import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import pipelineReducer from './reducers/pipelineReducer'

export const store = configureStore({
  reducer: {
    pipeline: pipelineReducer,
  },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
